import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Select, Tooltip, Modal, Checkbox } from "antd";
import { ColumnProps } from "antd/lib/table";
import { Widget, Button, Table, OptionProps } from "@digital/ui";
import { deleteDocumento, downloadArquivo, downloadArquivosOrdemCompra, getArquivosDocumento, getDocumentosOrdemCompraId, incluirDocumento, substituirAnexoDocumentoOrdemCompra, updateSasDocumentoOrdemCompraCommand, viewArquivo } from '@app/api/sas/sasDocumentoOrdemCompra';
import { getAllSasStatusDocumentoOrdemCompraOptions } from '@app/api/status';
import { GetFileExtension, imageFormats } from '@app/helpers';
import ModalComentarioDocumento from './ModalComentarioDocumento';
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import { getDadosGerais, OrdemCompraDadosGerais } from '@app/api/sas/ordemCompra';
import { ordemCompraIdState, reloadAnexosState, fluxoProcessoState, reloadState, stepState, desabilitarAcoesState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';
import { baixarTemplateCartaConvite } from '@app/api/template';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { Space, Visibility } from '@app/components';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import ModalDeleteAnexo from './ModalDeleteAnexo';
import { UploadModalHistorico } from '@app/components/Upload/uploadModalHistorico';
import { IArquivo } from '@app/types/core.types';
import ModalConfirmarHandover from './ModalConfirmarHandover';
import { EStatusOrdemCompra } from '@app/enums/EStatusOrdemCompra';

const { Panel } = Collapse;

interface Props {
    ehFornecedor?: boolean;
}

const WidgetDocumentacao = ({ ehFornecedor }: Props) => {
    const [documentos, setDocumentos] = useState([]);
    const [sasStatusDocumentoOrdemCompraOptions, setSasStatusDocumentoOrdemCompraOptions] = useState<OptionProps[]>([]);
    const [ordemCompra, setOrdemCompra] = useState<OrdemCompraDadosGerais>();
    const fluxo = useRecoilValue(fluxoProcessoState);
    const [reloadAnexos, setReloadAnexos] = useRecoilState(reloadAnexosState);
    const [reload, setReload] = useRecoilState(reloadState);
    const ordemCompraId: string = useRecoilValue(ordemCompraIdState);
    const step = useRecoilValue(stepState);
    const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);

    const onUpdateAnexos = () => {
        setReloadAnexos(!reloadAnexos);
    };

    useEffect(() => {
        getAllSasStatusDocumentoOrdemCompraOptions().then(data => {
            if (data) setSasStatusDocumentoOrdemCompraOptions(data);
        });
    }, []);

    useEffect(() => {
        if (ordemCompraId) {
            getDadosGerais(ordemCompraId)
                .then(data => {
                    if (data) {
                        setOrdemCompra(data);
                    }
                });
        }
    }, [ordemCompraId]);


    useEffect(() => {
        getDocumentosOrdemCompraId({
            ordemCompraId
        }).then(data => {
            if (data) {
                setDocumentos(data);
            }
        });
    }, [reloadAnexos, reload, step]);

    const onChangeExibirFornecedor = (documentoId: string, exibirFornecedor: boolean) => {
        updateSasDocumentoOrdemCompraCommand({
            sasDocumentoOrdemCompraId: documentoId,
            exibirFornecedor: exibirFornecedor
        }).then(data => {
            if (data) onUpdateAnexos();
        });
    };

    const onChangeStatus = (documentoId: string, statusId: string) => {
        updateSasDocumentoOrdemCompraCommand({
            sasDocumentoOrdemCompraId: documentoId,
            sasStatusDocumentoOrdemCompraId: statusId
        }).then(data => {
            if (data) onUpdateAnexos();
        });
    };

    const columns = () => {
        let columns: ColumnProps<any>[] = [];

        columns.push({
            title: 'Descrição',
            dataIndex: 'descricao',
            // width: '30%'
        });

        columns.push({
            title: 'Arquivo',
            dataIndex: 'arquivoNomeDownload',
            width: '30%'
        });

        hasPermission(["SAS_COMENTARIO_ANEXO_COLUNA"]) && (
            columns.push({
                title: "Comentários",
                width: "5%",
                className: "td-centralizado",
                render: (index: number, record: any) => (
                    <Tooltip title="Comentários">
                        <ModalComentarioDocumento
                            documentoId={record.id}
                            contemComentario={record.contemComentario}
                            disabled={desabilitarAcoes}
                        />
                    </Tooltip>
                )
            })
        );

        if (!ehFornecedor) {

            columns.push({
                title: 'Status',
                dataIndex: 'status',
                width: '10%',
                render(text, record, index) {
                    
                    // const aguardandoAnaliseDoc = ordemCompra && [
                    //     EStatusOrdemCompra.AguardandoAnaliseDocumentacao,
                    // ].includes(ordemCompra.statusCodigo);
                    const value = sasStatusDocumentoOrdemCompraOptions.find(el => el.value === record.sasStatusDocumentoOrdemCompraId);
                    const emRevisao = value && value.text === "Em revisão";
                    return (
                        <Select
                            style={{ width: '100%' }}
                            value={record.sasStatusDocumentoOrdemCompraId}
                            onSelect={e => onChangeStatus(record.id, e)}
                            disabled={
                                !hasPermission(["SAS_EXIBIR_FORNECEDOR_COLUNA"])
                                || record.sasStatusDocumentoOrdemCompraId == null
                                || desabilitarAcoes
                                || !emRevisao && (fluxo !== EGuidFluxoProcessoEtapa.AnaliseDocumentacao)
                            }
                        >
                            {sasStatusDocumentoOrdemCompraOptions.map(option => {
                                return <Select.Option value={option.value}>{option.text}</Select.Option>;
                            })}
                        </Select>);
                },
            });

            columns.push({
                title: "Exibir Fornecedor",
                width: "5%",
                className: "td-centralizado",
                render: (index: number, record: any) => (
                    <Checkbox
                        checked={record.exibirFornecedor}
                        onChange={(e) => {
                            onChangeExibirFornecedor(record.id, e.target.checked);
                        }}
                        disabled={desabilitarAcoes}
                    />
                )
            });

            columns.push({
                title: () => "Histórico",
                width: "5%",
                className: "td-centralizado",
                render: (index: number, record: any) => (
                    <>
                        {/* <ModalHistoricoArquivo sasDocumentoOrdemComraId={record.id} /> */}
                        <UploadModalHistorico
                            tooltip="Visualizar Histórico do Documento"
                            title="Histórico de Arquivos"
                            hasJustification={false}
                            hasDatePicker={false}
                            hasUpload={false}
                            onGetArquivos={async () => {
                                return await getArquivosDocumento(record.id)
                                    .then((data: any) => {
                                        return data;
                                    });
                            }}
                            arquivoActions={{
                                onDownload: (arquivo: IArquivo) => {
                                    downloadArquivo(
                                        arquivo.id,
                                        arquivo.nome
                                    );
                                },
                                onView(arquivo: IArquivo) {
                                    viewArquivo(
                                        arquivo.id,
                                        arquivo.nome
                                    );
                                },
                            }}
                        />
                    </>
                )
            });
        }


        columns.push({
            title: 'Ações',
            dataIndex: '',
            className: 'td-inicio',
            width: '5%',
            render(text, record, index) {
                return <>
                    <Visibility
                        visible={hasPermission(["SAS_ORDENS_COMPRA_SUBSTITUIR_ANEXO"]) && desabilitarAcoes === false}
                    >
                        <UploadModalHistorico
                            tooltip={!record.arquivoId || record.multiple ? "Adicionar Arquivo" : "Substituir Anexo"}
                            title={!record.arquivoId || record.multiple ? "Adicionar Arquivo" : "Substituir Anexo"}
                            buttonIcon='ui-upload'
                            hasJustification={record.arquivoId && record.multiple == false}
                            hasDatePicker={false}
                            hasUpload={true}
                            showUploadList={true}
                            onSubmit={async (values) => {
                                return await substituirAnexoDocumentoOrdemCompra({
                                    justificativa: values.justificativa || "",
                                    arquivo: values.arquivo,
                                    sasDocumentoOrdemCompraId: record.id,
                                    validaJustificativa: record.arquivoId && record.multiple == false ? 'true' : 'false'
                                }).then((data: any) => {
                                    if (data && data.valid) {
                                        onUpdateAnexos();
                                        return true;
                                    }
                                    return false;
                                });
                            }
                            }
                        />
                    </Visibility>

                    <Visibility
                        visible={isObjNotEmpty(record.arquivoId)}
                    >
                        <Tooltip title="Download Arquivo">
                            <Button
                                icon="ui-download"
                                type="link"
                                onClick={() => {
                                    downloadArquivo(
                                        record.arquivoId,
                                        record.arquivoNomeDownload
                                    );
                                }}
                            />
                        </Tooltip>
                    </Visibility>

                    <Visibility
                        visible={GetFileExtension(record.arquivoNomeDownload) === "pdf" ||
                            imageFormats.includes(
                                GetFileExtension(record.arquivoNomeDownload)
                            )}
                    >
                        <Tooltip title="Visualizar Arquivo">
                            <Button
                                icon="files-view_file"
                                type="link"
                                onClick={() => {
                                    viewArquivo(
                                        record.arquivoId,
                                        record.arquivoNomeDownload
                                    );
                                }}
                            />
                        </Tooltip>
                    </Visibility>

                    <Visibility
                        visible={record.multiple && !record.fixo && desabilitarAcoes === false}
                        permissions={["SAS_ORDENS_COMPRA_SUBSTITUIR_ANEXO"]}
                    >
                        <ModalDeleteAnexo sasDocumentoOrdemComraId={record.id} />
                    </Visibility>

                    <Visibility
                        visible={!record.multiple && !record.fixo && desabilitarAcoes === false}
                        permissions={["SAS_ORDENS_COMPRA_SUBSTITUIR_ANEXO"]}
                    >
                        <Tooltip title="Deletar Anexos">
                            <Button
                                onClick={() => {
                                    Modal.confirm({
                                        title: 'Deletar Item',
                                        icon: <Icon type="info-circle" />,
                                        content: 'Deseja excluir todos esses registros, incluindo todo seu histórico?',
                                        onOk() {
                                            deleteDocumento(record.id, record.arquivoId)
                                                .then(data => {
                                                    if (data) {
                                                        setReloadAnexos(!reloadAnexos);
                                                    }
                                                });
                                        },
                                    });
                                }}
                                icon="commons-trash"
                            />
                        </Tooltip>
                    </Visibility>

                    <>
                        {(record.tipoDocumentoOrdemCompraId && [EGuidTipoSasDocumento.CartaConvite].includes(record.tipoDocumentoOrdemCompraId)) ? (
                            <Tooltip title="Baixar Template">
                                <Button
                                    icon="business-new_resume_template"
                                    onClick={() => baixarTemplateCartaConvite()}
                                />
                            </Tooltip>
                        ) : (
                            <></>
                        )}
                    </>
                </>;
            },
        });

        return columns;
    };


    return (
        <>
            {((hasPermission(["SAS_VISUALIZAR_ACOMPANHAMENTO_CONTRATACAO"])
                || hasPermissionPerfil([
                    EGuidPerfilAcesso.GerenciaSenior,
                    EGuidPerfilAcesso.AdministradorContratoMRN,
                ]))
                || ehFornecedor == true
            ) && (
                    <Collapse
                        bordered={false}
                        defaultActiveKey={step
                            && isObjNotEmpty(step)
                            && step && 'fluxoEtapaId' in step
                            && [EGuidFluxoProcessoEtapa.AnaliseDocumentacao, EGuidFluxoProcessoEtapa.EnvioDaCartaConvite].toString().includes(step.fluxoEtapaId)
                            ? "documentacaoContratacao"
                            : ""
                        }
                        expandIcon={() => <Icon type="arrows-right_4" />}
                    >
                        <Panel
                            key={"documentacaoContratacao"}
                            header={"Documentação de Contratação" + (ehFornecedor == true && ordemCompra && isObjNotEmpty(ordemCompra) ? ` - OC ${ordemCompra.numero}` : "")} >

                            <Widget actions={[
                                <>
                                    <Button
                                        type='primary'
                                        onClick={() => downloadArquivosOrdemCompra({
                                            ordemCompraId: ordemCompraId,
                                            ordemCompraNumero: ordemCompra.numero,
                                            isOrdem: true,
                                            ehArquivoConsolidacaoAnexosFinais: false
                                        })}
                                    >Baixar Tudo
                                    </Button>
                                </>
                            ]} >

                                <Visibility
                                    visible={hasPermission(["SAS_ORDENS_COMPRA_SUBSTITUIR_ANEXO"])}
                                >
                                    <UploadModalHistorico
                                        tooltip="INCLUIR ANEXO"
                                        title="INCLUIR ANEXO"
                                        buttonUploadText='ADICIONAR ARQUIVO'
                                        buttonModalText='INCLUIR ANEXO'
                                        buttonIcon='ui-upload'
                                        hasJustification={true}
                                        labelJustification='Descrição do Documento'
                                        placeholderJustification='Descrição do Documento'
                                        hasDatePicker={false}
                                        hasUpload={true}
                                        showUploadList={true}
                                        onSubmit={async (values) =>
                                            await incluirDocumento({
                                                ordemCompraId: ordemCompraId,
                                                descricao: values.justificativa,
                                                file: values.arquivo,
                                            }).then((data: any) => {
                                                if (data && data.valid) {
                                                    onUpdateAnexos();
                                                    return true;
                                                }
                                                return false;
                                            })
                                        }
                                        buttonModalFooterText='Salvar'
                                        visible={desabilitarAcoes === false}
                                    />
                                    <Space mb={16} />
                                </Visibility>

                                <Table
                                    dataSource={documentos.ativos}
                                    columns={columns()}
                                    pagination={false}
                                />
                            </Widget>
                        </Panel>
                    </Collapse>
                )
            }
        </>
    );
};

export default WidgetDocumentacao;